import { FC } from "react";
import { OrganicTabsDashboard } from "../components";

const OrganicMediaDashboard: FC = () => {
  return (
    <div className="organic-media-dashboard-with-data">
      <OrganicTabsDashboard />
    </div>
  );
};

export default OrganicMediaDashboard;

